module.exports = __webpack_public_path__ + "static/media/IMG_3660.aaead12a.JPG";